import { AzureAuthorityHosts } from '@azure/identity';
import { z } from 'zod/v4';

export enum MicrosoftCloud {
  Public = 'public',
  UsGovernment = 'us_government',
}

export const microsoftCloudSchema = z.enum(MicrosoftCloud).default(MicrosoftCloud.Public);

export interface MicrosoftCloudProfile {
  authorityHost: AzureAuthorityHosts;
  graphBaseUrl: string;
  graphScope: string;
  azureManagementEndpoint: string;
  azureManagementScope: string;
}

const microsoftCloudProfiles = {
  [MicrosoftCloud.Public]: {
    authorityHost: AzureAuthorityHosts.AzurePublicCloud,
    graphBaseUrl: 'https://graph.microsoft.com',
    graphScope: 'https://graph.microsoft.com/.default',
    azureManagementEndpoint: 'https://management.azure.com',
    azureManagementScope: 'https://management.azure.com/.default',
  },
  [MicrosoftCloud.UsGovernment]: {
    authorityHost: AzureAuthorityHosts.AzureGovernment,
    graphBaseUrl: 'https://graph.microsoft.us',
    graphScope: 'https://graph.microsoft.us/.default',
    azureManagementEndpoint: 'https://management.usgovcloudapi.net',
    azureManagementScope: 'https://management.usgovcloudapi.net/.default',
  },
} satisfies Record<MicrosoftCloud, MicrosoftCloudProfile>;

export function getMicrosoftCloudProfile(cloud: MicrosoftCloud): MicrosoftCloudProfile {
  return microsoftCloudProfiles[cloud];
}
